import { createApp } from 'vue'
import App from '@/App.vue'
import ElementPlus from 'element-plus'
// 自定义 国际化语言
import i18n from "@/i18n/il8n";
import 'element-plus/theme-chalk/index.css';
import {createPinia} from 'pinia'
import piniaPluginpersistedstate from 'pinia-plugin-persist'
import * as Icons from '@element-plus/icons'
import "@/icons/index"; // 将src/icons/index.js引入
import SvgIcon from "@/components/icon/SvgIcon.vue"; // 引入SvgIcon.vue
import router from '@/router'

const pinia = createPinia();
pinia.use(piniaPluginpersistedstate);


const app = createApp(App)
app.use(ElementPlus)
    .use(router)
    .use(pinia)
    .use(i18n)
    .component("svg-icon", SvgIcon)
    .mount('#app')

Object.keys(Icons).forEach(key => { app.component(key, Icons[key]) })


/**
 * 解决resize报错
 * @param fn
 * @param delay
 * @returns {(function(): void)|*}
 */
const debounce = (fn, delay) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
    constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
    }
}
